import PropTypes from "prop-types";
import { Link } from "react-router-dom";

export default function ContentCard({
  icon,
  title,
  htmlTitle,
  desc,
  href,
  target,
  containerClassName,
  className,
  onClick,
  type,
  data,
}) {
  const handleClick = (event) => {
    if (onClick) {
      event.preventDefault();
      onClick();
    }
  };

  const cardContent = () => (
    <div
      className={`
        border-[1px] bg-[#F8F8F8] border-[#E3E3E3] text-center items-center justify-center rounded-[4px] p-[20px] flex flex-col gap-5
        ${
          (type === "account" || type === "venue" || type === "scan" || type === "weather" ) &&
          "aspect-square"
        }
        ${(type === "account" || type === "venue") && "m-2"}
        ${(type === "venue" || type === "participants" || type === "weather") && "gap-2"}
        ${type === "weather" && "m-0"}
        ${type === "participants" && "px-[14px]"}
        ${className}
      `}
      data-testid="card-content-classes"
    >
      {icon && (
        <div>
          <img
            src={icon}
            alt={title}
            className={`
              w-[50px] h-[50px]
              ${type === "scan" && "!w-10 !h-10"}
            `}
          />
        </div>
      )}

      {(htmlTitle || (title !== null && title !== "null") ) && (
        <div
          className={`
          font-semibold leading-6 font-poppins
          ${(type === "venue" || type === "weather") && "text-[24px] leading-[34px]"}
          ${type === "participants" && "text-[32px] leading-[42px]"}
          ${type === "scan" && "text-[16px] leading-[26px] text-white"}
        `}
        >
          {htmlTitle ? (
            <div dangerouslySetInnerHTML={{ __html: title }}></div>
          ) : (
            title
          )}
        </div>
      )}

      {desc && (
        <div
          className={`
          font-poppins font-semibold capitalize
          ${type === "venue" || type === "weather" && "text-[12px] leading-6 tracking-[0.2em] text-[#727272]"}
          ${type === "venue" && "text-[16px] leading-[26px] text-[#101820]"}
          ${type === "weather" && "!uppercase "}
        `}
        >
          {desc}
        </div>
      )}
    </div>
  );

  return href ? (
    <Link
      className={`${
        (type === "account" || type === "venue" || type === "scan" || type === "weather") &&
        "w-1/2 aspect-square "
      } ${containerClassName}`}
      to={href}
      target={target}
      onClick={handleClick}
      state={{ data }}
    >
      {cardContent()}
    </Link>
  ) : (
    <div
      onClick={handleClick}
      className={`${
        (type === "account" || type === "venue" || type === "scan") &&
        "w-1/2 aspect-square"
      }
      ${
        (type === "weather") &&
        "aspect-square"
      } ${containerClassName}`}
      data-testid="content-card-container"
    >
      {cardContent()}
    </div>
  );
}

ContentCard.propTypes = {
  icon: PropTypes.string,
  htmlTitle: PropTypes.bool,
  desc: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  containerClassName: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
};
